import StreamConfig from "../views/StreamConfig/StreamConfig";
import SystemConfig from "../views/SysConfig/SysConfig";
import Streams from "../views/Streams/Streams";
import Login from "../views/Pages/LoginPage";

const dashboardRoutes = [
  {
    path: "/dashboard",
    private: true,
    name: "Dashboard",
    icon: "pe-7s-graph",
    component: Streams
  },
  {
    path: "/streamconfig/:id",
    private: true,
    // name: "Stream Configuration",
    component: StreamConfig
  },
  {
    path: "/streamconfig",
    private: true,
    name: "Stream Configuration",
    icon: "pe-7s-note2",
    component: StreamConfig
  },
  {
    path: "/settings",
    private: true,
    name: "Settings",
    icon: "pe-7s-note2",
    component: SystemConfig
  },
  {
    path: "/login",
    name: "Login",
    icon: "pe-7s-users",
    component: Login
  },
  {
    path: "/logout",
    name: "Login",
    icon: "pe-7s-users",
    component: Login
  }
  // ,

  //  { redirect: true, path: "/", to: "/dashboard", name: "Dashboard" }
];

export default dashboardRoutes;
